var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ele-body wit imgbox"},[_c('div',{staticClass:"child-item"},[_c('div',{staticClass:"child-img"}),_c('div',{staticClass:"mar-top10"},[_vm._v("该功能暂未开放，研发中敬请期待")])])])
}]

export { render, staticRenderFns }